import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SalesCatalystTargetMarketInput from './SalesCatalystTargetMarketInput';
import TargetMarketAttitude from './TargetMarketAttitude';
import SalesCatalystSubEntityBarChart from './SalesCatalystSubEntityBarChart';
import SalesCatalystBrandBarChart from './SalesCatalystBrandBarChart';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';
import { INGSIGHT_360_BRANDS_REPORT_NAME, INGSIGHT_360_MEDIA_REPORT_NAME } from '../../../constants';


class SalesCatalystTargetMarket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  getfilterSearchResult = (category, searchVal, callback) => {
    const scFilterSearchParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      reportName:
        category === 'brands'
          ? INGSIGHT_360_BRANDS_REPORT_NAME
          : INGSIGHT_360_MEDIA_REPORT_NAME,
      searchText: searchVal,
      productNo: this.props.productNo,
    };
    this.props.salesCatalystActions
      .getCategorySearchList(scFilterSearchParams)
      .then(response => {
        const responseData = [];
        if (response.length > 0) {
          response.forEach(data => {
            responseData.push({
              value: data.subCategory,
              label: data.categoryLabel,
            });
          });
          callback(responseData);
        } else {
          callback(responseData);
        }
      });
  };

  render() {
    return (
      <div>
        <div className="sc-panel-width"><SalesCatalystTargetMarketInput color={this.props.color} /></div>
        <div className="large-12 medium-12 small-12 columns panel-layout-padding" ><TargetMarketAttitude  color={this.props.color}/></div>
        <div className="large-12 medium-12 small-12 columns panel-layout-padding">
          <SalesCatalystSubEntityBarChart
            title={this.props.entityTargetOverlap}
            getfilterSearchResult={this.getfilterSearchResult}
            componentInfo={{ category: 'media' }}
            selectedFilters={
              this.props.scTarget.selectedFilters.media
            }
          />
        </div>
        <div className="large-12 medium-12 small-12 columns panel-layout-padding">
          <SalesCatalystBrandBarChart
            title={this.props.entityTargetOverlap}
            getfilterSearchResult={this.getfilterSearchResult}
            componentInfo={{ category: 'brands' }}
            selectedFilters={
              this.props.scTarget.selectedFilters.brands
            }
          />
        </div>
      </div>
  );
  }
}

SalesCatalystTargetMarket.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  entityTargetOverlap: PropTypes.string,
  scTarget: PropTypes.shape({
    selectedFilters: PropTypes.shape({}),
  }),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    entityTargetOverlap: (state.salesCatalyst.dataSelection.targetMarket.length > 0 &&
      state.salesCatalyst.dataSelection.entity.length > 0)
      ? `${state.salesCatalyst.dataSelection.targetMarket[0].label} AND ${state.salesCatalyst.dataSelection.entity[0].label}` : '',
    scTarget: state.salesCatalyst.scTarget,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesCatalystTargetMarket);
